if (!customElements.get('pack-quantity-selector')) {
  customElements.define(
    'pack-quantity-selector',
    class PackQuantitySelector extends HTMLElement {
      constructor() {
        super();
        this.input =
          (this.dataset.quantityTarget && document.getElementById(this.dataset.quantityTarget)) ||
          this.querySelector('[data-pack-quantity-input]');
        this.priceContainer =
          this.dataset.priceTarget && document.getElementById(this.dataset.priceTarget)?.querySelector('.price');

        this.addEventListener('change', this.onOptionChange.bind(this));

        const checkedOption = this.querySelector('input[type="radio"]:checked');
        if (checkedOption) this.updatePrice(checkedOption);
      }

      onOptionChange(event) {
        if (event.target.type !== 'radio') return;

        if (this.input) {
          this.input.value = event.target.value;
          this.input.dispatchEvent(new Event('change', { bubbles: true }));
        }

        this.updatePrice(event.target);
      }

      updatePrice(option) {
        if (!this.priceContainer) return;

        const discount = parseFloat(option.dataset.discount || '0');
        const regularPrice = option.dataset.regularPrice;
        const salePrice = option.dataset.salePrice;
        if (!regularPrice || !salePrice) return;

        this.priceContainer.querySelectorAll('.price-item--regular').forEach((el) => {
          el.textContent = regularPrice;
        });

        const saleEl = this.priceContainer.querySelector('.price-item--sale');
        if (saleEl) saleEl.textContent = salePrice;

        this.priceContainer.classList.toggle('price--on-sale', discount > 0);
      }
    }
  );
}
